export default "__VITE_ASSET__D52REM48__"